import { Role } from './Role';
import { Partner } from './Partner';
import { Roles } from '@/types';

export class User {
    public id!: string;
    // public username!: string;
    public email!: string;
    public firstName!: string;
    public lastName!: string;
    public partner?: Partner;
    public emailConfirmed: boolean;
    public accessFailedCount: number;
    public lockoutEnd?: Date;
    public locked: boolean;
    public roles!: Role[];

    constructor() {
        this.emailConfirmed = false;
        this.accessFailedCount = 0;
        this.roles = [];
        this.locked = false;
    }

    public isAdministrator(): boolean {
        return this.roles && this.roles.some((role) => role.name === Roles.Administrators);
    }
}
